import { iconsAndImages } from "../../assets/images";
import srkInfraJson from "./srkInfrastructure..json";
import "./infrastructureStyle.scss";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

export const SrkInfrastructure = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true
        });
    }, []);
    return (
        <section className="py-5 infrastructure-section">
            <div className="container">
                <div className="row align-items-center gy-5">
                    <div className="col-12 col-lg-6" data-aos="fade-right">
                        <div className="infra-img-wrap">
                            <img
                                loading="lazy"
                                src={iconsAndImages?.[srkInfraJson?.leftImage]}
                                alt="srk-infrastructure"
                                className="img-fluid w-100 rounded-4 shadow infra-img"
                            />
                        </div>
                    </div>
                    <div className="col-12 col-lg-6" data-aos="fade-left">
                        <div>
                            <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
                                <img
                                    loading="lazy"
                                    src={iconsAndImages[srkInfraJson?.srkInfraImg]}
                                    alt=""
                                    className="infra-icon"
                                />
                                <p className="text-color fw-bold mb-0">
                                    {srkInfraJson?.info}
                                </p>
                            </div>

                            <h2 className="bebas-neue-regular mb-3 infra-title">
                                {srkInfraJson?.title}
                            </h2>
                            <p
                                className="infra-desc"
                                dangerouslySetInnerHTML={{
                                    __html: srkInfraJson?.subContent,
                                }}
                            />
                            <div className="infra-highlight p-3 mt-4">
                                <p className="mb-0 small text-color">
                                    {srkInfraJson?.infrastructureDetails}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};